
const styleLevel = [

  {

    cardGrid: {
      gridTemplateColumns: '1fr 1fr',
    },

    img: {
      width: '285px',
      height: '285px',
    },

    back: {
      width: '285px',
      height: '285px',
    }

  },

  {
    cardGrid: {
      gridTemplateColumns: '1fr 1fr 1fr 1fr',
    },

    img: {
      width: '130px',
      height: '130px',
    },

    back: {
      width: '130px',
      height: '130px',
    }
  },

  {
    cardGrid: {
      gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr',
    },

    img: {
      width: '88px',
      height: '88px',
    },

    back: {
      width: '88px',
      height: '88px',
    }
  },

  {
    cardGrid: {
      gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr',
    },

    img: {
      width: '64px',
      height: '64px',
    },

    back: {
      width: '64px',
      height: '64px',
    }
  }
]

export { styleLevel };